import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;

  background: #f6f6f6;
  box-sizing: border-box;
`;

export const Header = styled.div`
  box-sizing: border-box;

  width: 100%;
  padding: 24px;
  background-color: #212c3b;

  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const UserInfo = styled.div`
  position: relative;
  display: flex;

  cursor: pointer;
  margin-left: auto;
`;

export const UserInfoData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;

  font-size: 14px;
  color: #ffffff;
  cursor: pointer;

  p {
    margin: 0;
  }
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #212c3b;

  p {
    margin: 0 0 2px;
    font-weight: bold;
  }

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  bottom: calc(-100% - 12px);
  right: 0;

  background-color: #f9f9f9;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  border-radius: 4px;
`;

export const DropdownItem = styled.div`
  padding: 12px 16px;
  transition: 0.1s;
  border-radius: 4px;

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const Delete = styled.div`
  box-sizing: border-box;
  width: 100%;

  margin-top: 20%;
`;

export const DeleteContainer = styled.div`
  border-radius: 8px;
  padding: 24px;
  margin: auto 24px;

  color: #2a3748;
  background-color: #fff;

  display: flex;
  flex-direction: column;

  h1 {
    font-size: 20px;
    margin: 0;
  }

  p {
    font-size: 16px;
    color: #333333;
  }

  button {
    margin-top: 10px;
    margin-left: auto;
  }
`;
